module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.authCompleted) ? _c('div', {
    staticClass: "sk-connect-page"
  }, [_c('div', {
    staticClass: "sk-topbar sk-topbar-with-action"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "sk-topbar-logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$root.signOutUser()
      }
    }
  }, [_vm._v("Log out")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-steps-bar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sk-step-connector"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-step",
    class: _vm.currentStep === 5 ? 'sk-step-done' : 'sk-step-active'
  }, [_c('span', {
    staticClass: "sk-step-num"
  }, [_vm._v(_vm._s(_vm.currentStep === 5 ? '✓' : '2'))]), _vm._v("\n      Connect Amazon\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-main-wide"
  }, [(_vm.welcomeMode && _vm.currentStep === 4 && !_vm.loadingText) ? _c('div', {
    staticClass: "sk-welcome-strip"
  }, [(_vm.welcomeMode === 'sso') ? [_c('p', {
    staticClass: "sk-welcome-main"
  }, [_vm._v("Your account is ready"), (_vm.welcomeName) ? _c('span', [_vm._v(", " + _vm._s(_vm.welcomeName))]) : _vm._e(), _vm._v(". One step left.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-welcome-sub"
  }, [_vm._v("Signed in as " + _vm._s(_vm.$root.userEmail) + " · "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.notYou
    }
  }, [_vm._v("Not you?")])])] : [_c('p', {
    staticClass: "sk-welcome-main"
  }, [_vm._v("You're signed in as " + _vm._s(_vm.$root.userEmail) + ". One step left: connect your Amazon store.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-welcome-sub"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.notYou
    }
  }, [_vm._v("Not you?")])])]], 2) : _vm._e(), _vm._v(" "), (_vm.loadingText) ? _c('div', {
    staticClass: "sk-two-col-card sk-loading-card"
  }, [_c('div', {
    staticClass: "sk-spinner",
    staticStyle: {
      "margin": "0 auto 16px"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "var(--sk-text-mid, #4a6080)"
    }
  }, [_vm._v(_vm._s(_vm.loadingText))])]) : (_vm.currentStep === 4 && _vm.freeSubscriptionReady) ? _c('div', {
    key: "step-4",
    staticClass: "sk-two-col-card"
  }, [_c('div', {
    staticClass: "sk-trust-panel"
  }, [_c('h2', {
    staticClass: "sk-steps-heading"
  }, [_vm._v("What happens when you click Connect")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sk-help"
  }, [_c('img', {
    staticClass: "sk-help-photo",
    attrs: {
      "src": _vm.raghavPhoto,
      "alt": "Raghav from SentryKit"
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "sk-help-title"
  }, [_vm._v("Rather connect it together?")]), _vm._v(" "), _c('p', {
    staticClass: "sk-help-copy"
  }, [_vm._v("I'm Raghav from SentryKit. Book a call and we'll connect your store together, or ask me anything first.")]), _vm._v(" "), _c('div', {
    staticClass: "sk-help-actions"
  }, [_c('button', {
    staticClass: "sk-help-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.bookCall
    }
  }, [_vm._v("Book a call")]), _vm._v(" "), _c('button', {
    staticClass: "sk-help-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openChat
    }
  }, [_vm._v("Chat with me")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-form-panel sk-connect-form-panel"
  }, [(_vm.billingSetupWarning) ? _c('div', {
    staticClass: "sk-billing-warning"
  }, [_c('span', [_vm._v(_vm._s(_vm.billingSetupWarning))]), _vm._v(" "), _c('button', {
    staticClass: "sk-billing-warning-retry",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ensureFreeSubscriptionThenConnect
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), _c('connect-region-form', {
    attrs: {
      "working": _vm.connecting,
      "copying": _vm.copyingLink,
      "error": _vm.cardError,
      "show-teammate-link": true,
      "link-note": _vm.linkNote
    },
    on: {
      "connect": _vm.startConnect,
      "copy-link": _vm.copyTeammateLink
    }
  })], 1)]) : (_vm.currentStep === 5) ? _c('div', {
    key: "step-5",
    staticClass: "sk-two-col-card sk-success-card"
  }, [_c('div', {
    staticClass: "sk-success-wrap"
  }, [_c('div', {
    staticClass: "sk-success-icon"
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "#16a34a"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("You're all set!")]), _vm._v(" "), _c('p', [_vm._v("Your SentryKit account is ready. Amazon is loading your store and ASINs — this usually takes a few minutes.")]), _vm._v(" "), _c('button', {
    staticClass: "sk-cta-btn",
    staticStyle: {
      "max-width": "320px",
      "margin": "0 auto"
    },
    on: {
      "click": _vm.goToDashboard
    }
  }, [_vm._v("\n          Go to Dashboard →\n        ")])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-step sk-step-done"
  }, [_c('span', {
    staticClass: "sk-step-num"
  }, [_vm._v("✓")]), _vm._v("\n      Create Account\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "sk-steps"
  }, [_c('li', [_c('span', {
    staticClass: "sk-step-n"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Approve on Amazon.")]), _vm._v("\n              Sign in to Seller Central and approve SentryKit for the marketplaces you picked.\n            ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sk-step-n"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Your listings load on their own.")]), _vm._v("\n              Every ASIN in those marketplaces is added for you. Nothing to upload or copy.\n            ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "sk-step-n"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Monitoring starts.")]), _vm._v("\n              Alerts come to your email. Send them to Slack, Teams or ClickUp whenever you like.\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d529a0d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ConnectSellerAccountPage.vue
// module id = 757
// module chunks = 2